<template>
    <div class="mb-3">
        <div class="mb-2">
            <span>{{ name }}</span>
            <b-badge v-if="quantity" class="ml-2" variant="secondary">
                {{ quantity }}
            </b-badge>
        </div>
        <b-progress height="15px">
            <b-progress-bar :value="getProgress">
                <h6 class="mb-0">
                    {{ `${getProgress.toFixed(2)}%` }}
                </h6>
            </b-progress-bar>
        </b-progress>
    </div>
</template>

<script>
export default {
    name: 'ProgressInfo',
    props: ['quantity', 'progress', 'name'],
    computed: {
        getProgress() {
            return this.progress !== null ? this.progress : 0
        },
    },
}
</script>
